"use client";

import { c as _c } from "react/compiler-runtime";
import { MoonIcon, SunIcon } from "@phosphor-icons/react";
import { useCallback, useEffect, useRef, useState } from "react";
import { flushSync } from "react-dom";
import { cn } from "@/lib/utils";
interface AnimatedThemeTogglerProps extends React.ComponentPropsWithoutRef<"button"> {
  duration?: number;
}
export const AnimatedThemeToggler = t0 => {
  const $ = _c(19);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      duration: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const duration = t1 === undefined ? 400 : t1;
  const [isDark, setIsDark] = useState(false);
  const buttonRef = useRef(null);
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const updateTheme = () => {
        setIsDark(document.documentElement.classList.contains("dark"));
      };
      updateTheme();
      const observer = new MutationObserver(updateTheme);
      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ["class"]
      });
      return () => observer.disconnect();
    };
    t3 = [];
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== duration || $[7] !== isDark) {
    t4 = async () => {
      if (!buttonRef.current) {
        return;
      }
      await document.startViewTransition(() => {
        flushSync(() => {
          const newTheme = !isDark;
          setIsDark(newTheme);
          document.documentElement.classList.toggle("dark");
          localStorage.setItem("theme", newTheme ? "dark" : "light");
        });
      }).ready;
      const {
        top,
        left,
        width,
        height
      } = buttonRef.current.getBoundingClientRect();
      const x = left + width / 2;
      const y = top + height / 2;
      const maxRadius = Math.hypot(Math.max(left, window.innerWidth - left), Math.max(top, window.innerHeight - top));
      document.documentElement.animate({
        clipPath: [`circle(0px at ${x}px ${y}px)`, `circle(${maxRadius}px at ${x}px ${y}px)`]
      }, {
        duration,
        easing: "ease-in-out",
        pseudoElement: "::view-transition-new(root)"
      });
    };
    $[6] = duration;
    $[7] = isDark;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const toggleTheme = t4;
  let t5;
  if ($[9] !== className) {
    t5 = cn(className);
    $[9] = className;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== isDark) {
    t6 = isDark ? <SunIcon /> : <MoonIcon />;
    $[11] = isDark;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="sr-only">Toggle theme</span>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== props || $[15] !== t5 || $[16] !== t6 || $[17] !== toggleTheme) {
    t8 = <button ref={buttonRef} onClick={toggleTheme} className={t5} {...props}>{t6}{t7}</button>;
    $[14] = props;
    $[15] = t5;
    $[16] = t6;
    $[17] = toggleTheme;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};